import { Game } from "../interfaces/game.interface";
import axios from "axios";

class GameService {
  baseUrl: string;
  constructor() {
    this.baseUrl = process.env.REACT_APP_BACKEND || "";
  }
  // v1
  getGames(userId: string) {
    return new Promise<Game[]>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/game_list/api/game-list?userId=${userId}`,
      })
        .then((res: { data: { success: boolean; data: Game[] } }) => {
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.data);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }
  getGameDetail(gameId: string, userId: string) {
    return new Promise<Game>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/game_list/api/game-by-gameId?gameId=${gameId}&userId=${userId}`,
      })
        .then((res: { data: { success: boolean; data: Game } }) => {
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.data);
          }
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  }

  likeGame(userId: string, gameId: string, isLiked: boolean) {
    return new Promise<boolean>((resolve, reject) => {
      axios({
        method: "POST",
        url: `${this.baseUrl}/game_users/api/add-user-like-game`,
        data: {
          userId,
          gameId,
          isLiked,
        },
      })
        .then((res: { data: { success: boolean; data: string } }) => {
          if (res.data.success) {
            resolve(res.data.success);
          } else {
            reject(res.data.success);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }

  favoriteGame(userId: string, gameId: string, favorite: boolean) {
    return new Promise<boolean>((resolve, reject) => {
      axios({
        method: "POST",
        url: `${this.baseUrl}/game_users/api/add-favorite-game`,
        data: {
          userId,
          gameId,
          favorite,
        },
      })
        .then((res: { data: { success: boolean; data: string } }) => {
          if (res.data.success) {
            resolve(res.data.success);
          } else {
            reject(res.data.success);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }

  getFavoriteGames(userId: string) {
    return new Promise<Game[]>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/game_users/api/favorite-games?userId=${userId}`,
      })
        .then((res: { data: { success: boolean; data: Game[] } }) => {
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.data);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }

  rateGame(userId: string, gameId: string, rating: number) {
    return new Promise<boolean>((resolve, reject) => {
      axios({
        method: "POST",
        url: `${this.baseUrl}/game_users/api/rate-game`,
        data: {
          userId,
          gameId,
          rating,
        },
      })
        .then((res: { data: { success: boolean } }) => {
          resolve(res.data.success);
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }

  // v2
}

export const gameService = new GameService();
